import React from 'react';

import { Box } from '@mafc/trolly';
import { COLORS } from '@mafc/common';

interface IProps {
  [key: string]: any;
}

const BlockTitle: React.FC<IProps> = ({ stacked, ...rest }) => (
  <Box
    as="h2"
    fontSize={3}
    fontWeight={8}
    mx={[2, 4, null, 0]}
    mt={[null, null, null, stacked ? 4 : 0]}
    mb={3}
    color={COLORS.BLACK}
    {...rest}
  />
);

export default BlockTitle;
